export default class GuysTime {
  constructor() {
    this.state = {
      beer: null,
    };

    this.init();
  }

  init() {
    this.handleScroll();
    this.handleBeerSelector();
    this.handleReset();
  }

  handleReset() {
    const $arrow = $('.js-btn-reset');

    $arrow.click((e) => {
      if ($('.js-hero-' + this.state.beer).hasClass('active')) {
        $('.js-hero-' + this.state.beer).removeClass('active');
        $('.js-hero-2').removeClass('deactive');
        $('.js-hero-1').removeClass('deactive').addClass('active');
      }

      $('.js-page-' + this.state.beer).fadeOut(500, () => {
        $('.js-page-1').fadeIn(500);
      });

      $('.js-scroll-arrow.scroll-arrow-black').show();
      $('.js-scroll-arrow.scroll-arrow-white').hide();
    });
  }

  handleScroll() {
    $(window).scroll(function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() / 2) {
        if (!$('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').addClass('rotated');
        }

        if ($('.js-hero-1').hasClass('active')) {
          $('.js-hero-1').removeClass('active').addClass('deactive');
          $('.js-hero-2').addClass('active');
        }
      } else if ($(window).scrollTop() + $(window).height() < $(document).height() / 2) {
        if ($('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').removeClass('rotated');
        }

        if ($('.js-hero-2').hasClass('active')) {
          $('.js-hero-2').removeClass('active');
          $('.js-hero-1').removeClass('deactive').addClass('active');
        }
      }
    });

    const $arrow = $('.js-scroll-arrow');

    $arrow.click((e) => {
      if ($(e.currentTarget).hasClass('rotated')) {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      } else {
        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
      }
    });
  }

  handleBeerSelector() {
    const $beers = $('ul.beer-selector').children('li.beer');

    $beers.click((e) => {
      this.state.beer = $(e.currentTarget).data('beer');

      if ($('.js-hero-1').hasClass('active')) {
        $('.js-hero-1').removeClass('active').addClass('deactive');
        $('.js-hero-' + this.state.beer).addClass('active');
      } else if ($('.js-hero-2').hasClass('active')) {
        $('.js-hero-2').removeClass('active').addClass('deactive');
        $('.js-hero-' + this.state.beer).addClass('active');
      }

      $('html, body').animate(
        {
          scrollTop: 0,
        },
        {
          duration: 1000,
          complete: () => {
            $('.js-page-1').fadeOut(500, () => {
              $('.js-page-' + this.state.beer).fadeIn(500);
              $('.js-scroll-arrow.scroll-arrow-black').hide();
              $('.js-scroll-arrow.scroll-arrow-white').show();
            });
          },
        }
      );
    });
  }
}
